import {
  ADD_INVOICE_PAYMENT,
  CLEAN_INVOICE,
  DELETE_INVOICE_PAYMENT,
  FETCH_INVOICE_PAYMENTS,
  FETCH_INVOICE_SUCCESS,
  invoiceActionTypes,
  invoiceReducerType,
  INVOICE_INIT_STATE,
  UPDATE_INVOICE_PAYMENT,
  UPDATE_INVOICE_SUCCESS,
} from './types';

export default function invoiceReducer(
  state: invoiceReducerType = INVOICE_INIT_STATE,
  action: invoiceActionTypes,
): invoiceReducerType {
  switch (action.type) {
    case FETCH_INVOICE_SUCCESS:
      return {
        ...state,
        invoice: action.invoice,
      };
    case FETCH_INVOICE_PAYMENTS:
      return {
        ...state,
        invoicePayments: action.invoicePayments,
      };
    case UPDATE_INVOICE_SUCCESS:
      return {
        ...state,
        invoicePayments: [],
        isFinished: true,
      };
    case ADD_INVOICE_PAYMENT:
      return {
        ...state,
        invoicePayments: [...state.invoicePayments, action.invoicePayment],
      };
    case UPDATE_INVOICE_PAYMENT:
      return {
        ...state,
        invoicePayments: state.invoicePayments.map((p, i) =>
          action.index === i ? action.invoicePayment : p,
        ),
      };
    case DELETE_INVOICE_PAYMENT:
      return {
        ...state,
        invoicePayments: state.invoicePayments.filter((p, i) => action.index !== i),
      };
    case CLEAN_INVOICE:
      return {
        ...INVOICE_INIT_STATE,
        refresh: state.refresh,
      };
    default:
      return state;
  }
}
